import { acceptHMRUpdate, defineStore } from 'pinia'

import cookieUtils from '@/lib/utils/cookies'

import { useSessionStore } from '@/stores/session'

type State = {
  punchoutDunsId: string | null
  punchoutRedirectUrl: string | null
  isPunchoutSession: boolean
}
type Actions = {
  punchoutLogout: () => Promise<void>
  initPunchoutState: () => void
  resetState: () => void
}

export const usePunchoutStore = defineStore<string, State, Record<string, never>, Actions>(
  'punchout',
  {
    state: () => ({
      punchoutDunsId: null,
      punchoutRedirectUrl: null,
      isPunchoutSession: false,
    }),

    actions: {
      async punchoutLogout() {
        this.$reset()
        const sessionStore = useSessionStore()
        await sessionStore.logout()
      },

      initPunchoutState() {
        const punchoutDunsId = cookieUtils.getCookie('punchoutDunsId')
        const punchoutRedirectUrl = cookieUtils.getCookie('punchoutRedirectUrl')

        this.punchoutDunsId = punchoutDunsId || null
        this.punchoutRedirectUrl = punchoutRedirectUrl || null

        if (punchoutDunsId && punchoutRedirectUrl) {
          this.isPunchoutSession = true
        }

        cookieUtils.removeCookie('punchoutDunsId')
        cookieUtils.removeCookie('punchoutRedirectUrl')
      },

      resetState() {
        this.$reset()
      },
    },
  },
)

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(usePunchoutStore, import.meta.hot))
}
